import { render, staticRenderFns } from "./dept_import_user_table.vue?vue&type=template&id=2b42858c&"
import script from "./dept_import_user_table.vue?vue&type=script&lang=js&"
export * from "./dept_import_user_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports